// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
}

export const loanTypesUpdateRequestSchema: Array<StaticFieldSchema> = [
  {
    key: 'name',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'name',
  },
  {
    key: 'finalStatementEnabled',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'finalStatementEnabled',
  },
  {
    key: 'statementLogicVersion',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'statementLogicVersion',
    numberFormat: 'integer',
  },
  {
    key: 'statementTestLogicVersion',
    type: 'number',
    required: false,
    component: 'NumberInput',
    fullPath: 'statementTestLogicVersion',
    numberFormat: 'integer',
  },
  {
    key: 'assetDisplayName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'assetDisplayName',
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'creditReporting',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'creditReporting',
    nested: [
      {
        key: 'isCreditReportingAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'creditReporting.isCreditReportingAllowed',
      },
      {
        key: 'metro2',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'creditReporting.metro2',
        nested: [
          {
            key: 'innovisProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisProgramIdentifier',
          },
          {
            key: 'equifaxProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxProgramIdentifier',
          },
          {
            key: 'experianProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianProgramIdentifier',
          },
          {
            key: 'transunionProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionProgramIdentifier',
          },
          {
            key: 'reporterName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterName',
          },
          {
            key: 'reporterAddress',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterAddress',
          },
          {
            key: 'reporterTelephoneNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterTelephoneNumber',
          },
          {
            key: 'softwareVendorName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVendorName',
          },
          {
            key: 'softwareVersionNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVersionNumber',
          },
          {
            key: 'microBiltPrbcProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.microBiltPrbcProgramIdentifier',
          },
          {
            key: 'innovisIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisIdentificationNumber',
          },
          {
            key: 'equifaxIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxIdentificationNumber',
          },
          {
            key: 'experianIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianIdentificationNumber',
          },
          {
            key: 'transunionIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionIdentificationNumber',
          },
          {
            key: 'portfolioType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.portfolioType',
            options: ['C', 'I', 'M', 'O', 'R'],
          },
          {
            key: 'accountType',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.accountType',
          },
          {
            key: 'interestTypeIndicator',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.interestTypeIndicator',
          },
          {
            key: 'creditorClassification',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.creditorClassification',
            options: [
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
            ],
          },
          {
            key: 'skipSegments',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'creditReporting.metro2.skipSegments',
            nested: [
              {
                key: '0',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath: 'creditReporting.metro2.skipSegments[0]',
                options: [
                  'header',
                  'baseSegment',
                  'k1Segment',
                  'k2Segment',
                  'l1Segment',
                ],
              },
            ],
          },
          {
            key: 'roundingMethod',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.roundingMethod',
            options: ['roundDownWhole', 'roundUpWhole'],
          },
        ],
      },
    ],
  },
  {
    key: 'dueDates',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'dueDates',
    nested: [
      {
        key: 'frequencyChangesLimits',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'dueDates.frequencyChangesLimits',
        nested: [
          {
            key: 'buffer',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'dueDates.frequencyChangesLimits.buffer',
            numberFormat: 'integer',
          },
          {
            key: 'maxNumberOfAllowedChanges',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath:
              'dueDates.frequencyChangesLimits.maxNumberOfAllowedChanges',
            numberFormat: 'integer',
          },
        ],
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(loanTypesUpdateRequestSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(loanTypesUpdateRequestSchema)
}
